import classes from "./MapContainer.module.css";
import React, { useState, Fragment, useEffect, useRef } from "react";

import LeftPanel from "../../../layout/leftPanel/LeftPanel";
import MapContentForLeftPanel from "../leftPanelContent/MapContentForLeftPanel";
import RightPanel from "../../../layout/rightPanel/RightPanel";
import RightPanelContent from "../rightPanelContent/RightPanelContent";
import { useAllContexts } from "../../../hooks/useAllContexts";
// import VerticalSidePanel from "./../../components/UI/panel/VerticalSidePanel";
// import Vertical from "../../components/forms/vertical/Vertical";

let listener = null;
const MapContainer = ({
  searchInput,
  setSearchInput,
  filtersVar,
  setFiltersVars,
  clearVarsHandler,
  mobilityMap,
  selectedRoad,
  ...props
}) => {
  const { variables } = useAllContexts();
  const {
    getSelectedItem,
    setShowInfoPanel,
    showInfoPanel,
    showAnimation,
    setShowAnimation,
  } = variables;
  let listener = useRef(null);
  // const [showInfoPanel, setShowInfoPanel] = useState(false);

  useEffect(() => {
    if (getSelectedItem === null) {
      setShowInfoPanel(false);
    }
  }, [getSelectedItem]);

  const close = () => {
    setShowInfoPanel(false);
  };

  useEffect(() => {
    if (showInfoPanel && showAnimation) {
      clearTimeout(listener.current);
      setShowInfoPanel(false);
      listener.current = setTimeout(() => setShowInfoPanel(true), 250);
    } else if (showAnimation) {
      setShowInfoPanel(true);
    }

    return () => clearTimeout(listener.current);
  }, [showAnimation]);

  return (
    <Fragment>
      <LeftPanel open>
        <MapContentForLeftPanel
          searchInput={searchInput}
          setSearchInput={setSearchInput}
          filtersVar={filtersVar}
          setFiltersVars={setFiltersVars}
          clearVarsHandler={clearVarsHandler}
          showAnimation={showAnimation}
          close={close}
          mobilityMap={mobilityMap}
          selectedRoad={{ ...selectedRoad }}
        />
      </LeftPanel>
      <RightPanel show={showInfoPanel} close={close}>
        <RightPanelContent close={close} showAnimation={showAnimation} />
      </RightPanel>
      <div className={props.mapFrame ? classes.wrapper_full : classes.wrapper}>
        {React.cloneElement(props.children, {
          showAnimation,
        })}
      </div>
    </Fragment>
  );
};

export default MapContainer;
